import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackFunnelEvent } from './funnelTracker.js'

/**
 * Mount once under the router. Fires `landing_view` for the storefront root.
 *
 * Only the root path: the backend records `landingPath` on the first
 * `landing_view` and ignores later ones, so firing on every route would add rows
 * that change nothing. `/checkout` reports itself via `checkout_started` instead.
 */
export function useFunnelTracker() {
  const { pathname } = useLocation()

  useEffect(() => {
    if (pathname === '/') {
      trackFunnelEvent({ type: 'landing_view', path: '/', scopeKey: 'landing_root' })
    }
  }, [pathname])
}
